import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import {
  AnimatedRefreshIconComponent,
  BreadcrumbsComponent,
  CalendlyPopupButtonComponent,
  ClipboardCompatComponent,
  ConfirmDialogService,
  DateTimeDisplayComponent,
  DialogLoadingViewComponent,
  DialogService,
  EmailSettingsComponent,
  FlatTableNgComponent,
  LayoutWithCollapsiblePaneComponent,
  LegacyDialogHeaderComponent,
  LegacyDialogFooterComponent,
  LoaderComponent,
  ModeStudioComponent,
  NewContainerMenuComponent,
  PaginatorComponent,
  ReportCreationShortcutsComponent,
  ReportTypeIconComponent,
  SelectWithSearchComponent,
  SimpleErrorComponent,
  SlackChannelSelectorComponent,
  SortSettingsModalDialogService,
  SqlNoResultsMessageComponent,
  StarComponent,
  StudioSeatLimitBannerComponent,
  TableLoadingComponent,
  TimeAgoComponent,
  ToggleSwitchComponent,
  TrialBannerComponent,
  TrialEndedDialogLauncherComponent,
  TrialEndedDialogService,
  WorkspaceAvatarComponent,
  UpgradeBannerComponent,
  HeaderComponent,
  StatusBannerComponent,
} from '@mode/shared/ui';
import { PlanSelectionComponent } from '@mode/signup/feature-plan';
import { ExploreConnectModeDbComponent } from '@mode/datasources/feature-connect-database';
import * as angular from 'angular';

export const DowngradedSharedUIModule = angular
  .module('downgraded-shared-ui', [])
  .directive('modeAnimatedRefreshIcon', downgradeComponent({ component: AnimatedRefreshIconComponent }))
  .directive('modeBreadcrumbs', downgradeComponent({ component: BreadcrumbsComponent }))
  .directive('modeCalendlyPopupButton', downgradeComponent({ component: CalendlyPopupButtonComponent }))
  .directive('modeClipboardCompat', downgradeComponent({ component: ClipboardCompatComponent }))
  .directive('modeDateTimeDisplay', downgradeComponent({ component: DateTimeDisplayComponent }))
  .directive('modeDialogLoadingView', downgradeComponent({ component: DialogLoadingViewComponent }))
  .directive('modeEmailSettings', downgradeComponent({ component: EmailSettingsComponent }))
  .directive('modeExploreConnectModeDb', downgradeComponent({ component: ExploreConnectModeDbComponent }))
  .directive('modeEmailSettingsHeader', downgradeComponent({ component: HeaderComponent }))
  .directive('modeFlatTableNg', downgradeComponent({ component: FlatTableNgComponent }))
  .directive('modeLegacyDialogHeader', downgradeComponent({ component: LegacyDialogHeaderComponent }))
  .directive('modeLegacyDialogFooter', downgradeComponent({ component: LegacyDialogFooterComponent }))
  .directive('modeLoader', downgradeComponent({ component: LoaderComponent }))
  .directive('modeNewContainerMenu', downgradeComponent({ component: NewContainerMenuComponent }))
  .directive('modePaginatorComponent', downgradeComponent({ component: PaginatorComponent }))
  .directive('modePlanSelection', downgradeComponent({ component: PlanSelectionComponent }))
  .directive('modeReportCreationShortcuts', downgradeComponent({ component: ReportCreationShortcutsComponent }))
  .directive('modeReportTypeIcon', downgradeComponent({ component: ReportTypeIconComponent }))
  .directive('modeSelectWithSearch', downgradeComponent({ component: SelectWithSearchComponent }))
  .directive('modeSimpleError', downgradeComponent({ component: SimpleErrorComponent }))
  .directive('modeSlackChannelSelector', downgradeComponent({ component: SlackChannelSelectorComponent }))
  .directive('modeSqlNoResultsMessage', downgradeComponent({ component: SqlNoResultsMessageComponent }))
  .directive('modeStar', downgradeComponent({ component: StarComponent }))
  .directive('modeStatusBanner', downgradeComponent({ component: StatusBannerComponent }))
  .directive('modeStudio', downgradeComponent({ component: ModeStudioComponent }))
  .directive('modeStudioSeatLimitBanner', downgradeComponent({ component: StudioSeatLimitBannerComponent }))
  .directive('modeTableLoading', downgradeComponent({ component: TableLoadingComponent }))
  .directive('modeTimeAgo', downgradeComponent({ component: TimeAgoComponent }))
  .directive('modeToggleSwitch', downgradeComponent({ component: ToggleSwitchComponent }))
  .directive('modeTrialBanner', downgradeComponent({ component: TrialBannerComponent }))
  .directive('modeTrialEndedDialogLauncher', downgradeComponent({ component: TrialEndedDialogLauncherComponent }))
  .directive('modeUpgradeBanner', downgradeComponent({ component: UpgradeBannerComponent }))
  .directive('modeWorkspaceAvatar', downgradeComponent({ component: WorkspaceAvatarComponent }))
  .directive('modeLayoutWithCollapsiblePane', downgradeComponent({ component: LayoutWithCollapsiblePaneComponent }))
  .service('ConfirmDialogService', downgradeInjectable(ConfirmDialogService))
  .service('DialogService', downgradeInjectable(DialogService))
  .service('SortSettingsModalDialogService', downgradeInjectable(SortSettingsModalDialogService))
  .service('TrialEndedDialogService', downgradeInjectable(TrialEndedDialogService)).name;
